<script setup lang="ts">
  import type { HTMLAttributes } from 'vue';

  import { cn } from '@ui/utils/utils';

  const props = defineProps<{ class?: HTMLAttributes['class'] }>();
</script>

<template>
  <i class="fa far fa-spinner-third" :class="cn('animate-spin', props.class)" />
</template>

<style scoped></style>
